import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import "./index.css";

function EditQuestionForm (props) {
    const {
        questionName,
        questionAnswer,
        handleSubmit,
        thisQuestionAnswer,
        index,
    } = props;

    const [question, setQuestion] = useState("");
    const [answer, setAnswer] = useState(null);
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        setQuestion(questionName);
        setAnswer(questionAnswer);
    }, []);

    const handleChange = (e) => {
        setQuestion(e.target.value);
    }

    const handleDropdownChange = (e) => {
        setAnswer(e.target.innerText.trim());
    }

    const submit = (e) => {
        e.preventDefault();
        handleSubmit(thisQuestionAnswer, {question, answer, isEditing});
        setIsEditing(false);
    }

    const handleDelete = () => {
        props.handleDelete(thisQuestionAnswer);
    }

    const handleOpen = () => {
        setIsEditing(true);
    }

    const handleClose = () => {
        setIsEditing(false);
    }

    return (
        <div>
            {isEditing ?
                <form onSubmit={submit} className="questionForm">
                    <h2>New Question</h2>
                    <TextField
                        hintText="Question Text"
                        style={{paddingTop: "0px", paddingBottom: "20px"}}
                        name="question"
                        onChange={handleChange}
                        value={question}
                        multiLine={true}
                        rows={1}
                    />
                    <br/>
                    <SelectField
                        name="answer"
                        value={answer}
                        onChange={handleDropdownChange}
                        hintText={"Response Type"}
                        labelStyle={{textAlign: "left"}}
                        floatingLabelStyle={{paddingLeft: "0%"}}
                        style={{textAlign: "left"}}
                    >
                        <MenuItem
                            key="0text"
                            value="Text"
                            primaryText="Text"
                            id="answer"
                        />
                        <MenuItem
                            key="1range"
                            value="Range"
                            primaryText="Range"
                            id="answer"
                        />
                        <MenuItem
                            key="2yn"
                            value="Y/N"
                            primaryText="Y/N"
                            id="answer"
                        />
                    </SelectField>
                    <br/>
                    <button type="submit" className="actionButton assignmentQuestion">Save</button>
                    <button onClick={handleClose} className="actionButton assignmentQuestion">Close</button>
                </form>
                :
                <div className="mappedQuestion">
                    <h2>Question {index}</h2>
                    <h3>Question: <span className="mappedQuestionText">{questionName}</span></h3>
                    <h3>Answer Type: <span className="mappedQuestionText">{questionAnswer}</span></h3>
                    <button onClick={handleOpen} className="actionButton assignmentQuestion">Edit</button>
                    <button onClick={handleDelete} className="actionButton assignmentQuestion">Delete</button>
                </div>
            }
        </div>
    );
}

export default connect(state => state.root, {  })(EditQuestionForm);
